import React from 'react';
import { Button } from '@mui/material';
import { selectedButtonStyle1, selectedButtonStyle2, buttonStyle1, buttonStyle2 } from '../ReusableStyles/ButtonStyles';

interface SlidingButtonProps {
  isSelected: boolean;
  isSelectedFn: boolean;
  onClick: () => void;
}

const SlidingButton: React.FC<SlidingButtonProps> = ({ isSelected,isSelectedFn, onClick }) => {
  return (
    <div className="standingslidingBtn">
      <div style={isSelectedFn ? selectedButtonStyle1 : selectedButtonStyle2}></div>
      <Button
        variant="contained"
        color="inherit"
        size="small"
        onClick={onClick}
        sx={isSelected ? buttonStyle1 : buttonStyle2}
      >
        Sliding
      </Button>
    </div>
  );
};

export default SlidingButton;